import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UrbisoftMainStructureConfig} from '../../interfaces/urbisoft-main-structure-config.interface';
import {NgxSpinnerService} from 'ngx-spinner';
import {UrbisoftSpinnerConfig} from '../../interfaces/urbisoft-spinner-config.interface';

@Component({
  selector: 'app-urbisoft-main-structure',
  templateUrl: './urbisoft-main-structure.component.html',
  styleUrls: ['./urbisoft-main-structure.component.scss']
})
export class UrbisoftMainStructureComponent implements OnInit {
  @Input() urbisoftMainStructureConfig: UrbisoftMainStructureConfig;
  @Input() urbisoftSpinnerConfig: UrbisoftSpinnerConfig = {
    bdColor: 'rgba(51,51,51,0.9)',
    size: 'medium',
    color: '#fff',
    type: 'line-scale-pulse-out',
    text: 'Loading...'
  };
  @Input() isLoggedIn = false;
  toggleSideBar = new BehaviorSubject<boolean>(null);

  constructor(private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }

}
